import { ModuleWrapper } from '@/components'
import { Cell, Table } from '@/components_deprecated/Table'
import { PageType } from '@/modules/common/consts'
import { useQuery } from '@apollo/client'
import { Icon, Loader } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { useNavigate } from 'react-router'
import styled from 'styled-components'
import { SALARY_BASES } from './queries'
import { format } from '@/utils'

const ClickableRow = styled.tr`
  cursor: pointer;
`

export const SalaryBases: React.JSX.CFC = () => {
  const translations = useTranslate({
    name: 'common.name',
    created: 'common.created',
    edit: 'common.edit',
    delete: 'common.delete',

    missingExports: 'salary.missing-exports',
    salaryBases: 'salary.salary-bases',
    salaryBaseDate: [
      'salary.salary-base-date',
      { date: format(new Date(), 'dd.MM.yyyy') },
    ],
    completed: 'common.completed',
  })

  const navigate = useNavigate()

  const { data, loading } = useQuery(SALARY_BASES)

  if (loading) return <Loader.Dots />

  const salaryBases = data?.allSalaryBases ?? []

  return (
    <ModuleWrapper
      title={translations.salaryBases}
      page={PageType.SALARY_BASES}
      loading={loading}
    >
      <Table noBorders rowHoverBackground="gray10">
        <thead>
          <tr>
            <th>{translations.name}</th>
            <th>{translations.created}</th>
            <th className="text-center">{translations.completed}</th>
          </tr>
        </thead>

        <tbody>
          {salaryBases.map(salaryBase => (
            <ClickableRow
              key={salaryBase.id}
              onClick={() => void navigate(`/salary-bases/${salaryBase.id}`)}
            >
              <td>
                {salaryBase.year &&
                  salaryBase.month &&
                  translations.salaryBaseDate({
                    date: format(
                      new Date(salaryBase.year, salaryBase.month - 1),
                      'MMMM yyyy'
                    ),
                  })}
              </td>
              <td>{format(new Date(salaryBase.createdAt), 'dd.MM.yyyy')}</td>
              <Cell centered>
                <Icon
                  icon={salaryBase.missingExports ? 'close' : 'check'}
                  color={salaryBase.missingExports ? 'red' : 'green'}
                />
              </Cell>
            </ClickableRow>
          ))}
        </tbody>
      </Table>
    </ModuleWrapper>
  )
}
